export default __webpack_public_path__ + "static/media/es_es.b8fdcf33.png";